/* eslint-disable no-bitwise -- FNV hashing and UUID version/variant stamping are inherently bitwise */
/**
 * UUID helpers for entity ids (boards, cards, members, organizations, …).
 */

/** New random UUID for entities created at runtime. */
export function newUuid(): string {
   return crypto.randomUUID();
}

/**
 * Return a deterministic UUID (RFC 9562 version 8) for a seed key; the same
 * key always gives the same id. Not cryptographic.
 */
export function stableSeedUuid(seed_key: string): string {
   const bytes = new Uint8Array(16);

   // Fill 16 bytes from four salted FNV-1a passes over the key.
   for (let pass = 0; pass < 4; pass++) {
      let hash = FNV_OFFSET_BASIS ^ Math.imul(pass + 1, FNV_PASS_SALT);
      for (let i = 0; i < seed_key.length; i++) {
         hash ^= seed_key.charCodeAt(i);
         hash = Math.imul(hash, FNV_PRIME);
      }
      const offset = pass * 4;
      bytes[offset] = (hash >>> 24) & 0xFF;
      bytes[offset + 1] = (hash >>> 16) & 0xFF;
      bytes[offset + 2] = (hash >>> 8) & 0xFF;
      bytes[offset + 3] = hash & 0xFF;
   }

   // Stamp version (8 = custom) and RFC variant bits.
   bytes[6] = (bytes[6] & 0x0F) | 0x80;
   bytes[8] = (bytes[8] & 0x3F) | 0x80;

   const hex = [...bytes].map((byte) => byte.toString(16).padStart(2, '0')).join('');
   return [
      hex.slice(0, 8),
      hex.slice(8, 12),
      hex.slice(12, 16),
      hex.slice(16, 20),
      hex.slice(20),
   ].join('-');
}

const FNV_OFFSET_BASIS = 0x811C9DC5;
const FNV_PRIME = 0x01000193;
const FNV_PASS_SALT = 0x9E3779B9;
